// Define language on app
export default (Vue) => {
    Vue.lang = {
        // Set lang
        setLanguage(language) {
            window.localStorage.setItem('lang_amol', language);
        },
        // Get lang
        getLanguage(){
            let language = window.localStorage.getItem('lang_amol');
            if(!language || ! language)
            {
                return null;
            }
            return language;
        }
    }

    Object.defineProperties(Vue.prototype, {
        $lang: {
            get: () => {
                return Vue.lang
            }
        }
    });
}


// WEBPACK FOOTER //
// ./src/packages/lang/Lang.js